module.exports = __webpack_public_path__ + "img/game_phone_km.f4ab0c43.png";